import React from "react";
import { Link } from "react-router-dom";
// import logo from '../assets/images/logo.png';
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./Navbar.css"; // your custom styles
import logo from "../images/logo_ace.png";
import Dropdown from 'react-bootstrap/Dropdown';
import MissionStatement from "../mainpagelinks/aboutus/MissionStatement";


function NavScrollExample() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            alt="ACE Logo"
            height="60"
            className="d-inline-block align-top"
          />{" "}
        </Navbar.Brand>

        <Navbar.Brand as={Link} to="/">ACE International</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: "100px" }}
            navbarScroll
          >
            {/* <Nav.Link as={Link} to="/">Home</Nav.Link> */}
            {/* <Nav.Link as={Link} to="#action2">About Us</Nav.Link> */}

            <NavDropdown title="About Us" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="/MissionStatement">
                ACE Mission Statement
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/ManagementMessage">
                Management Message
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/GeneralInformation">
                General Information
              </NavDropdown.Item>
            </NavDropdown>

            {/* <NavDropdown title="Academics" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="/Primary">Primary</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/Secondary">Secondary / A Level</NavDropdown.Item> 
            </NavDropdown> */}



            {/* <NavDropdown title="Academics" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="Primary">Detail</NavDropdown.Item> */}
            {/* <NavDropdown.Divider /> */}
            {/* <NavDropdown.Item as={Link} to="/Primary">Primary</NavDropdown.Item> */}
            {/* <NavDropdown.Divider /> */}

            {/* Start of nested dropdown */}
            {/* <div className="dropdown-submenu"> */}
            {/* <NavDropdown.Item className="submenu-toggle" as={Link} to="/Secondary">Secondary / A Level ▸</NavDropdown.Item> */}
            {/* <ul className="dropdown-menu">
                <li><Link className="dropdown-item" as={Link} to="/Stage3">Key Stage 3333</Link></li>
                <li><Link className="dropdown-item" as={Link} to="/Stage4">Key Stage 4 (IGCSE)</Link></li>
                <li><Link className="dropdown-item" as={Link} to="/Stage5">Key Stage 5 (A Level)</Link></li>
                </ul> */}
            {/* </div> */}
            {/* </NavDropdown> */}




            <Nav.Link as={Link} to="Academics" >
              <div style={{ borderRight: '2px solid #ccc', height: '25px', borderWidth: '2px', borderColor: '#ccc', paddingRight: '10px', marginRight: '0px' }}>
                Academics
              </div>
            </Nav.Link>

            <Nav.Link as={Link} to="SchoolFee" >
              <div style={{ borderRight: '2px solid #ccc', height: '25px', borderWidth: '2px', borderColor: '#ccc', paddingRight: '10px', marginRight: '0px' }}>
                Admission
              </div>
            </Nav.Link>

          <NavDropdown
              title="Special Facilities"
              id="navbarScrollingDropdown"

            >
              <NavDropdown.Item as={Link} to="/Clubs">Clubs</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/Counsellor">Counsellor</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/Swimming">Swimming</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/Security">Security</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/Transport">Transport</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/Libraries">
                ACE International Acdemy Libraries
              </NavDropdown.Item>
            </NavDropdown> 

            {/* <Nav.Link as={Link} to="Primary" >
              <div style={{ borderRight: '2px solid #ccc', height: '25px', borderWidth: '2px', borderColor: '#ccc', paddingRight: '10px', marginRight: '0px' }}>
                Special Facilities
              </div>
            </Nav.Link> */}

            {/* <Nav.Link as={Link} to="Gallery">Gallery</Nav.Link> */}




            <NavDropdown title="Life at ACE" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="Gallery01">
                Gallery-1
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="Gallery02">
                Gallery-2
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="Gallery03">
                Gallery-3
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/event01">
              ACE Event-1
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/event02">
              ACE Event-2
              </NavDropdown.Item>
               <NavDropdown.Divider />
               <NavDropdown.Item as={Link} to="/event03">
               ACE Event-3
               </NavDropdown.Item>
            </NavDropdown>


            {/* <NavDropdown title="News & Letters" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="FAQ">
                Frequently Asked Questions
              </NavDropdown.Item>
            </NavDropdown> */}

            <NavDropdown title="Contact" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="Location">
                Location
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="ContactUs">
                Contact Us
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="FAQ">
                Frequently Asked Questions
              </NavDropdown.Item>
            </NavDropdown>

            {/* <Nav.Link as={Link} to="#" disabled>
              Contact
            </Nav.Link> */}
          </Nav>


          <Form className="d-flex">
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
            />
            <Button variant="outline-success">Search</Button>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavScrollExample;

// const Navbar = () => (
//   <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm">
//     <div className="container">
//       <Link className="navbar-brand" to="/">
//         {/* <img src={logo} alt="Logo" height="40" /> */}
//         <span style={{ fontWeight: 'bold' }}>ACE International</span>
//       </Link>
//       <button
//         className="navbar-toggler"
//         type="button"
//         data-toggle="collapse"
//         data-target="#navMenu"
//       >
//         <span className="navbar-toggler-icon"></span>
//       </button>
//       <div className="collapse navbar-collapse" id="navMenu">
//         <ul className="navbar-nav ml-auto">
//           <li className="nav-item"><Link to="/" className="nav-link">Home</Link></li>
//           <li className="nav-item"><Link to="/about" className="nav-link">About DIS</Link></li>
//           <li className="nav-item"><Link to="/academics" className="nav-link">Academics</Link></li>
//           <li className="nav-item"><Link to="/facilities" className="nav-link">Facilities</Link></li>
//           <li className="nav-item"><Link to="/activities" className="nav-link">Activities</Link></li>
//           <li className="nav-item"><Link to="/careers" className="nav-link">Careers</Link></li>
//           <li className="nav-item"><Link to="/admissions" className="nav-link">Admissions</Link></li>
//           <li className="nav-item"><Link to="/gallery" className="nav-link">Gallery</Link></li>
//           <li className="nav-item"><Link to="/faqs" className="nav-link">FAQ's</Link></li>
//           <li className="nav-item"><Link to="/contact" className="nav-link">Contact</Link></li>
//         </ul>
//       </div>
//     </div>
//   </nav>
// );

// export default Navbar;
